// ============================================================
// APPOINTEXT — WORKSHOP REGISTRATION PAGE CONFIG
// All editable values and ALL page copy live here, not in JSX.
// ============================================================

// --- Third-party registration widget --------------------------
// Raw embed code from your form/webinar provider. Any <script>
// tags inside it ARE executed. Leave as "" to show the dashed
// "Registration widget goes here." placeholder instead.
export const WIDGET_EMBED_CODE = `<script src="https://d3pw37i36t41cq.cloudfront.net/embed_v2.js" async></script>
<script>
  window._wf = window._wf || [];
  _wf.push({ id: '2qA2vnM5ahSWW4HzKcEJVqwY' });
</script>`;

// --- Meta Pixel (optional) ------------------------------------
// Fires PageView on this page. (Lead fires on the thank-you page.)
// Leave empty ("") to disable. If you change the ID, also update
// the <noscript> fallback in public/index.html.
export const META_PIXEL_ID = "1799778891004549";

// --- Footer links ----------------------------------------------
export const PRIVACY_URL = "https://appointext.ai/privacy";
export const TERMS_URL = "https://appointext.ai/terms";

// --- Presenter photo -------------------------------------------
// Paste an image URL to replace the square placeholder.
export const PRESENTER_IMAGE_URL = "/assets/haroon.png";

// --- Copy -------------------------------------------------------
export const COPY = {
  eyebrow: "Free 60-minute workshop · Starts the moment you register",
  headlineMain: "Setters are",
  headlineAccent: "so 2025.",
  subhead:
    "See how high-ticket businesses are booking more calls, getting more of them to show up, and collecting more cash from the leads they already pay for, without spending more on ads and without a single setter on payroll.",
  // Phrases inside `subhead` that get the yellow marker highlight.
  subheadHighlights: [
    "booking more calls",
    "getting more of them to show up",
    "collecting more cash",
  ],
  // Phrases inside `subhead` that get the indigo underline.
  subheadUnderlines: [
    "without spending more on ads",
    "without a single setter on payroll",
  ],
  bullets: [
    "The real annual cost of one setter seat. You'll calculate your own number on a live calculator during the session, not take ours.",
    "The four things that decide whether a front end works — and which one of the four can honestly be trained.",
    "Your three real options, including the two that aren't us.",
  ],
  // Set to "" to hide this line (e.g. if the widget has its own).
  consentLine:
    "No cost. No pitch for the first 45 minutes. By entering your details you agree to receive the session link and follow-up by email and text. Reply STOP to opt out.",
  agendaHeading: "What we'll cover",
  agenda: [
    "Why the setter seat decides your revenue. Not your closer. Not your offer. The first touch.",
    "What running setters actually costs you in a year — calculated on your own numbers.",
    "The four non-negotiables, and which of them can actually be trained.",
    "Your three options, honestly compared.",
  ],
  presenterHeading: "Your host",
  presenterName: "Haroon Naseer",
  presenterBio:
    "Haroon Naseer has spent ten years in high-ticket sales — hiring setters, training setters, and losing setters. He started as a setter himself on 1% commission, has personally closed over 400 clients, and has worked with some of the most recognised names in the online high-ticket space.",
  forYouTitle: "This is for you if",
  forYouBody:
    "You sell a high-ticket offer that needs a conversation before it closes. Coaching, consulting, done-for-you services, insurance, real estate, SaaS — the industry matters less than whether somebody has to get on a call.",
  notForYouTitle: "This isn't for you if",
  notForYouBody:
    "You sell a physical product, or anything that closes without a human conversation. We'd rather tell you now than take an hour of your time.",
  finalCtaLine: "60 minutes. Your own numbers. Starts when you do.",
  finalCtaButton: "Register for FREE Workshop",
  liveBadge: "LIVE",
  sessionNowLine: "A session is starting now",
  navTrustLine: "2,000+ businesses · Fire your setter today",
  footerCopyright: "© Appointext.ai",
  footerPrivacy: "Privacy Policy",
  footerTerms: "Terms",
};
